import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import { normalizeSizeString } from 'app/util/sizes'
import classNames from 'lib/util/classNames'
import styles from './Title.module.scss'

/**
 * The `Title`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Title (props) {
  const { Tag, children, className, color, size, ...rest } = props
  const classNameOutput = useMemo(
    () =>
      classNames([
        className,
        styles.title,
        styles[`color-${color}`],
        styles[`size-${normalizeSizeString(size)}`]
      ]),
    [className, color, size]
  )

  return (
    <Tag className={classNameOutput} color={color} {...rest}>
      {children}
    </Tag>
  )
}

/** @type {object} */
Title.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  Tag: PropTypes.elementType,
  className: PropTypes.string,
  size: PropTypes.string
}

/** @type {object} */
Title.defaultProps = {
  Tag: 'h1',
  color: 'a',
  className: '',
  size: 'h1'
}

// Memoize
export default memo(Title)
